class MgmImageHotspots extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('click', this.onDocumentClick.bind(this));
    document.addEventListener('keydown', this.onKeydown.bind(this));
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick.bind(this));
    document.removeEventListener('keydown', this.onKeydown.bind(this));
  }

  onClick(event) {
    const trigger = event.target.closest('[data-mgm-hotspot-trigger]');
    if (!trigger || !this.contains(trigger)) return;

    const item = trigger.closest('[data-mgm-hotspot]');
    if (!(item instanceof HTMLElement)) return;

    event.preventDefault();
    event.stopPropagation();

    const isActive = item.dataset.active === 'true';
    this.closeAll();

    if (!isActive) {
      item.dataset.active = 'true';
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  onDocumentClick(event) {
    if (!this.contains(event.target)) this.closeAll();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.closeAll();
  }

  closeAll() {
    for (const item of this.querySelectorAll('[data-mgm-hotspot]')) {
      item.dataset.active = 'false';
      item.querySelector('[data-mgm-hotspot-trigger]')?.setAttribute('aria-expanded', 'false');
    }
  }
}

if (!customElements.get('mgm-image-hotspots')) {
  customElements.define('mgm-image-hotspots', MgmImageHotspots);
}
